import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "image-fullscreen-content" }
const _hoisted_2 = { class: "image-fullscreen-actions" }

import { mdiClose, mdiRotateRight } from '@mdi/js'
import ProtectedImage from './ProtectedImage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageFullscreenOverlay',
  props: {
    modelValue: { type: Boolean },
    biometryId: {},
    blobUrl: {},
    rotation: { default: 0 }
  },
  emits: ["update:modelValue", "update:rotation"],
  setup(__props: any, { emit }) {

const props = __props;





function handleRotate() {
  emit('update:rotation', (props.rotation + 90) % 360)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    fullscreen: "",
    scrim: "black",
    "content-class": "image-fullscreen-overlay",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "image-fullscreen-close",
          "aria-label": "Fechar",
          "data-testid": "fullscreen-close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
        }, [
          _createVNode(_component_v_icon, {
            size: "28",
            color: "#16161d"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(mdiClose)), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "image-fullscreen-action",
            "data-testid": "fullscreen-rotate-button",
            onClick: handleRotate
          }, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "#52526f"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(mdiRotateRight)), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(ProtectedImage, {
          "biometry-id": _ctx.biometryId,
          "blob-url": _ctx.blobUrl,
          rotation: _ctx.rotation,
          "img-class": "image-fullscreen-img",
          "container-class": "image-fullscreen-protected",
          "data-testid": "fullscreen-image"
        }, null, 8, ["biometry-id", "blob-url", "rotation"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})